import { configureStore } from '@reduxjs/toolkit'
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistStore } from 'redux-persist'
import deposit from '@mobi/account/Areas/Deposit/Store/deposit'
import signUp from '@mobi/account/Areas/SignUp/Store/'
import { betslip } from '@mobi/betslip/Store'
import { sportsOffering } from '@mobi/sports-offering/Store'
import accountActivity from '@core/Areas/Account/Pages/Activity/Store'
import appHeader from '@core/Areas/AppHeader/Store'
import blackbook from '@core/Areas/Blackbook/Store'
import favouriteNumbers from '@core/Areas/FavouriteNumbers/Store'
import kambi from '@core/Areas/KambiClient/Store'
import login, { setIsLoginShown } from '@core/Areas/Login/Store'
import meetings from '@core/Areas/Meetings/Store'
import navigation from '@core/Areas/Navigation/Store'
import notifications from '@core/Areas/Notifications/Store'
import quickDeposit from '@core/Areas/QuickDeposit/Store'
import raceCard from '@core/Areas/RaceCard/Store'
import skyRaces from '@core/Areas/RaceCardSky/Store'
import search from '@core/Areas/Search/Store'
import settings from '@core/Areas/Settings/Store'
import skyVideoPlayer from '@core/Areas/SkyVideoPlayer/Store'
import structuredSearch from '@core/Areas/StructuredSearch/Store'
import tipping from '@core/Areas/Tipping/Store'
import toolbox from '@core/Areas/Toolbox/Store'
import geoLocation from '@core/Areas/VenueMode/Store'
import modal, { closeModal, openModal } from '@core/Components/Modal/store'
import features from '@core/State/FeatureFlags/Store'
import appConfig from './Config'
import { listenerMiddleware } from './listenerMiddleware'

export const store = configureStore({
  reducer: {
    accountActivity,
    appConfig,
    appHeader,
    betslip,
    blackbook,
    deposit,
    favouriteNumbers,
    features,
    geoLocation,
    kambi,
    login,
    meetings,
    modal,
    navigation,
    notifications,
    quickDeposit,
    raceCard,
    search,
    settings,
    signUp,
    skyRaces,
    skyVideoPlayer,
    sportsOffering,
    structuredSearch,
    tipping,
    toolbox,
  },
  devTools: !PRODUCTION,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          openModal.type,
          closeModal.pending.type,
          setIsLoginShown.type,
        ],
        ignoredPaths: ['modal.items', 'login.onLoginSuccessCallback'],
      },
    }).prepend(listenerMiddleware.middleware),
})

export const persistor = persistStore(store)

// Types
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
